<template>
  <div
    id="product-share-page"
    :class="{ 'bottom-dot-7': product.status === 1 }"
  >
    <!-- 商品基本信息 -->
    <product-basic-info
      :price="product.sell_price"
      :name="product.product_name"
      :summary="product.parsedSummary"
      :continent="product.continent_id"
      v-if="product.parsedSummary"
    />

    <!--商品下架了-->
    <div v-if="product.status === 1" class="product-closed">
      <div class="product-closed-box">
        <img
          src="../../static/img/product-closed@2x.png"
          alt="product-closed"
          class="close-img"
        />
        <div class="close-head">很抱歉，该商品已下架</div>
        <div class="close-find-tips">
          <span v-if="product.product_list && product.product_list.length > 0"
            >为您找到相似产品，可能您会喜欢 :)</span
          >
          <span
            v-if="
              !product.product_list ||
              (product.product_list && product.product_list.length === 0)
            "
            >下载熊猫签证App可查看更多商品</span
          >
        </div>
      </div>

      <!-- 推荐的商品 -->
      <recommend-products
        v-bind:products="product.product_list"
        v-on:product="goToNewProject"
      />
    </div>

    <!-- 商品没有下架 -->
    <div class="bgcolor" v-else>
      <!--评价得分-->
      <rate-and-score
        :procedure="product.procedure"
        :pass-rate="product.pass_rate"
        :reviews="product.reviews"
        :sum-score="product.sum_score"
        v-if="product.procedure"
      />

      <!--所有身份的数据-->
      <all-identities-data
        :product-material="product.material"
        v-if="product.material"
        :have-id-photo="product.visa_photo_id"
      />

      <!-- 基本信息 -->
      <base-info :info="product.basic_info" />

      <!-- 办理步骤 -->
      <handle-progress :progress="product.handle_process" />

      <!-- 签证示例 -->
      <visa-page :visa-page-image="product.visa_page" />
    </div>

    <!-- 下载app -->
    <app-downLoad
      :channel="channel"
      :class="{ 'bottom-0': product.status === 1 }"
    />

    <!-- 底部跳转 -->
    <go-to-handle-page
      v-bind:product-closed="product.status === 1"
      :customer_service="product.customer_service"
      v-if="product.status !== 1"
    />
  </div>
</template>

<script>
import productBasicInfo from '../components/productBasicInfo';
import rateAndScore from '../components/rateAndScore';
import allIdentitiesData from '../components/allIdentitiesData';
import handleProgress from '../components/handleProgress';
import baseInfo from '../components/baseInfo';
import visaPage from '../components/visaPage';
import recommendProducts from '../components/recommendProducts';
import appDownLoad from '../components/appDownLoad';
import goToHandlePage from '../components/goToHandlePage';
import ProductService from '../services/productService';

export default {
  name: 'productShare',
  data() {
    return {
      product: {},
      allIdentitiesDatas: null,
      parsedIndentitiesDatas: [],
      productService: new ProductService(this.$http),
      channel: '6jj6u8io',
    };
  },
  components: {
    productBasicInfo,
    rateAndScore,
    allIdentitiesData,
    handleProgress,
    baseInfo,
    visaPage,
    recommendProducts,
    appDownLoad,
    goToHandlePage,
  },
  mounted() {
    this.getData(this.productService.getProductId());
  },
  watch: {
    $route() {
      this.goToNewProject(this.productService.getProductId());
    },
  },
  methods: {
    getData(projectId) {
      if (!projectId) return;
      this.productService.getProduct(projectId).then((response) => {
        const product = response.body.body;

        // 转化基本信息
        product.parsedSummary = this.productService.parseProductSummaryInfo(
          product.summary_info,
        );

        // 设置浏览器title
        document.title = `【熊猫签证】${product.product_name}`;

        this.product = product;

        this.$nextTick(() => {
          window.scrollTo(0, 0);
        });
      });
    },

    goToNewProject(product) {
      this.$router.push({
        path: '/productShare',
        query: { visa_product_id: product },
      });
      this.getData(product);
    },
  },
};
</script>

<style lang="less" scoped>
#product-share-page {
  &.bottom-dot-7 {
    padding-bottom: 0.7rem;
  }
  padding-bottom: 1.1rem;
  .bottom-0 {
    bottom: 0;
  }
  .product-closed {
    .product-closed-box {
      width: 3.55rem;
      height: 2.05rem;
      background-color: #fff;
      margin: 0 auto;
      margin-top: -0.1rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      .close-img {
        width: 1.25rem;
        height: 1.25rem;
        margin-top: 0.15rem;
      }
      .close-head {
        font-size: 0.15rem;
        line-height: 0.15rem;
        color: #444;
        margin-top: 0.1rem;
      }
      .close-find-tips {
        font-size: 0.13rem;
        font-size: 0.13rem;
        color: #aaa;
        margin-top: 0.09rem;
        margin-bottom: 0.15rem;
      }
    }
  }
}
</style>
